'use client'

/* eslint-disable no-trailing-spaces */
/* eslint-disable @typescript-eslint/no-floating-promises */

import React, { useEffect, useState } from 'react'
import { pageEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import RTODetailsData from './rtoData' 
import WidgetModal from '../common/widgetModal'
import styles from '../RtoVehicleInfo/rtoVehicleInfoWidgetModal.module.scss'
import { DASH_FALLBACK, RTO_DETAIL_WIDGET } from '../common/commonConstants'
import AppDownloadSection from '../common/appDownloadSection'
import { checkRTODetails } from '../common/helper'
import { commonWidgetConfig, vehicleTypeConfig } from '../common/commonWidgetConfig'
import { SEGMENT } from '../common/widgetSegments'

const RtoDetailWidgetModal = ({ vehicleData, regNo, setWidgetModal, phone, segmentEventCommonProperties, userData, KeyFeatures, setVehicleData, setRegNo }) => {
  const [rtoDetailIndex, setRtoDetailIndex] = useState<number>(0)

   useEffect(() => {
    checkRTODetails(regNo, RTODetailsData, setRtoDetailIndex)
  }, [])

    useEffect(() => {
          pageEvent(SEGMENT.VIEW_PAGE, {
            ...segmentEventCommonProperties,
            product: commonWidgetConfig?.product?.[RTO_DETAIL_WIDGET],
            phone: phone || userData?.phone,
            registration_number: regNo,
            vehicle_type: vehicleTypeConfig[vehicleData?.vehicle_type_v2] || vehicleTypeConfig.DEFAULT,
            mm_name: vehicleData?.model_name,
            previous_policy_expiry_date: vehicleData?.previous_policy_expiry_detail,
          })
        }, [])

  return (
    <WidgetModal setVehicleData={setVehicleData} setRegNo={setRegNo} setWidgetModal={setWidgetModal} vehicleData={vehicleData} regNo={regNo}>
      <div className={styles.vehicleInfoContainer}>
        <div className={styles.heading}>RTO information</div>
        <div className={styles.vehicleDetailsContainer}>
          <div className={styles.vehicleDetails}>
            <p>RTO number</p>
            <span>{RTODetailsData[rtoDetailIndex]?.Number || DASH_FALLBACK}</span>
          </div>
          <div className={styles.vehicleDetails}>
            <p>City | State</p>
            <span>{`${RTODetailsData[rtoDetailIndex]?.City || DASH_FALLBACK} | ${
              RTODetailsData[rtoDetailIndex]?.State || DASH_FALLBACK
            } `}</span>
          </div>
          <div className={styles.vehicleDetails}>
            <p>Phone</p>
            <span>{RTODetailsData[rtoDetailIndex]?.Phone || DASH_FALLBACK}</span>
          </div>
          <div className={styles.vehicleDetails}>
            <p>Email</p>
            <span>{RTODetailsData[rtoDetailIndex]?.Email || DASH_FALLBACK}</span>
          </div>
          <div className={styles.vehicleDetails}>
            <p>Address</p>
            <span>{RTODetailsData[rtoDetailIndex]?.Address || DASH_FALLBACK}</span>
          </div>
        </div>
      </div>
      <AppDownloadSection
        regNo={regNo}
        widgetType={RTO_DETAIL_WIDGET}
        KeyFeatures={KeyFeatures}
        segmentEventCommonProperties={segmentEventCommonProperties}
        phone={phone}
        userData={userData}
        vehicleData={vehicleData}
      />
    </WidgetModal>
  )
}

export default RtoDetailWidgetModal
